import { render, staticRenderFns } from "./MyEducation.vue?vue&type=template&id=5c7f78ca&scoped=true&"
import script from "./MyEducation.vue?vue&type=script&lang=js&"
export * from "./MyEducation.vue?vue&type=script&lang=js&"
import style0 from "./MyEducation.vue?vue&type=style&index=0&id=5c7f78ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f78ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
